import { useProfielImage } from "app/hooks/configurator/useProfielImage";
import { BusinessItemPricing } from "entities/product-item-price/BusinessItemPricing";
import { zakelijkProfielCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";
import { useMemo } from "react";
import { Product } from "shared/api/middleware-api-client";
import Heading from "shared/ui/typography/Heading";
import { isTestEnvironment } from "shared/utils/checkEnvironment";
import { concatClassnames } from "shared/utils/concatClassnames";
import { ZakelijkProduct } from "../../../shared/api/middleware-api-client/api";
import ZakelijkPaymentDoorProductItemConfigTable from "./ZakelijkPaymentDoorProductItemConfigTable";

interface ProductItemSidebarProps {
  product: Product | ZakelijkProduct;
}

const storageURL = isTestEnvironment()
  ? "https://storage.googleapis.com/gewoongers-staging/assets/zakelijk/"
  : "https://storage.googleapis.com/gewoongers-production/assets/zakelijk/";

const ZakelijkPaymentProductItemSidebar = ({
  product,
}: ProductItemSidebarProps) => {
  const { generateImageId } = useProfielImage({});

  //Show imageID based if its zakelijk door or profiel
  const imageID = useMemo(() => {
    if (zakelijkProfielCodes.includes(product.doorType.code)) {
      return generateImageId(product.doorLayout.code, product.doorColor.code);
    }

    return storageURL + product.doorType.code + ".jpg";
  }, [product, generateImageId]);

  // Name of the product
  const doorTypeName = product.doorType.name;

  return (
    <>
      <div
        className={concatClassnames(
          "gg-col-span-12",
          "gg-grid gg-grid-cols-12",
        )}
      >
        <div
          className={concatClassnames(
            "gg-col-span-12 gg-col-start-2 gg-mb-5 sm:gg-col-span-3 md:gg-col-span-4 lg:gg-col-span-3 xl:gg-col-span-5 2xl:gg-col-span-4",
          )}
        >
          <img
            src={imageID}
            className="!gg-h-24 !gg-w-24 gg-shrink-0 gg-object-cover gg-object-center sm:gg-h-28 sm:gg-w-28 md:!gg-h-40 md:!gg-w-40"
            alt={"alt"}
          />
        </div>

        <div
          className={concatClassnames(
            "gg-col-span-12 gg-col-start-2 gg-mb-5 gg-justify-center sm:gg-col-span-9 md:gg-col-span-6 lg:gg-col-span-7 xl:gg-col-span-7 2xl:gg-col-span-8",
          )}
        >
          <Heading headingLevel="h2" className="gg-mb-3">
            {doorTypeName}
          </Heading>

          <ZakelijkPaymentDoorProductItemConfigTable product={product} />
        </div>

        <BusinessItemPricing
          className={`gg-col-span-12 gg-col-start-2 gg-items-center gg-gap-x-4 sm:gg-col-start-4 md:gg-col-start-5 md:gg-col-end-11 lg:gg-col-span-full lg:gg-col-start-11 xl:gg-col-span-12 xl:gg-col-start-6 2xl:gg-col-start-5 2xl:gg-col-end-12`}
          product={product as Product}
        />
      </div>
    </>
  );
};
export default ZakelijkPaymentProductItemSidebar;
